import React, { Fragment, useState } from "react";
import Breadcrumb from "../../common/breadcrumb/breadcrumb";
import { Container, Col, Row, Button, Modal, ModalHeader, ModalBody, Form, Label } from "reactstrap";
import { v4 as uuidv4 } from 'uuid';

import { useSelector } from "react-redux";
import { useEffect } from "react";
import { API_NOTICE } from "../../../redux/apiRoutes";
import axios from "axios";
import { toast } from "react-toastify";
import { VerticalTimeline, VerticalTimelineElement } from "react-vertical-timeline-component";
import { Edit, Edit3, Image, Plus, Trash, User, Video } from "react-feather";
import { useForm } from "react-hook-form";

import Compressor from 'compressorjs';
import SweetAlert from "sweetalert2";
import { uploadImage, uploadDocument, deleteFile, extractFilenameFromUrl } from "../../../utils/fileUpload";

import CKEditors from "react-ckeditor-component";

const Home = () => {
  const user = useSelector((content) => content.User);

  const [modal, setModal] = useState(false);
  const toggle = () => {setModal(!modal);  reset(); setEditinNotice(false); clearModal();};

  const clearModal = () => {
    setFileImage('')
    setContent('')
    setFilePDF('')
  }

  const {
    register,
    handleSubmit,
    reset,
    setValue,
    formState: { errors },
  } = useForm();

  const [startDate, setstartDate] = useState(new Date());
  const handleChangeStart = (date) => {
    setstartDate(date);
  };

  const [fileImage, setFileImage] = useState('');
  const [filePDF, setFilePDF] = useState('');

  const [existNotices, setexistNotices] = useState(false);
  const [timeline, setTimeline] = useState([]);
  const [loadingTimeline, setLoadingTimeline] = useState(false);
  const getNotices = async () => {
    setLoadingTimeline(true);
      setexistNotices(true);
      await axios.get(`${API_NOTICE}?status=ACTIVE&limit=20`).then(response => {
        if(response.data.docs.length>0){
          setTimeline(response.data.docs);
        }else{
          setTimeline([]);
        }
        setLoadingTimeline(false);
      }).catch(e => {
        toast.error("No se pudo obtener el listado de notificaciones: " + e.message, {position: 'bottom-right', style:{color:'white'}});
        setLoadingTimeline(false);
      });
  }

  const [savingNotice, setSaveNotice] = useState(false);
  const saveNotice = async (data) => {
    setSaveNotice(true);
    if (data !== "") {
      data.uuid = uuidv4();
      data.creatorUuid = user.uuid;
      data.status = 'ACTIVE';
      data.description = content;

      try {
        // Upload PDF if exists
        if(filePDF !== ''){
          const pdfUrl = await uploadDocument(filePDF);
          data.files = [pdfUrl];
        }

        // Upload image if exists
        if(fileImage !== ''){
          let file = fileImage;

          new Compressor(file, {
            quality: 0.8,
            success: async (compressedResult) => {   
              const compressed = compressedResult;
              
              const imageUrl = await uploadImage(compressed);
              data.pictures = [imageUrl];
              
              if(data.urls !== ''){data.urls = [data.urls] }
              if(data.videos !== ''){data.videos = [data.videos] }
        
              await axios.post(`${API_NOTICE}`,data).then(response => {
                if(response.data){
                  toggle();
                  getNotices();
                  reset();
                  toast.success("¡Anuncio creado con éxito!", {position: 'bottom-right', style:{color:'white'}});
                }
                setSaveNotice(false);
              }).catch(e => {
                setSaveNotice(false);
                toast.error("No se pudo crear el anuncio: " + e.message, {position: 'bottom-right', style:{color:'white'}});
              });
            },
            error: (err) => {
              toast.error("Error al comprimir la imagen: "+err, {position: 'bottom-right', style:{color:'white'}});
              setSaveNotice(false);
            }
          });
        } else {
          if(data.urls !== ''){data.urls = [data.urls] }
          if(data.videos !== ''){data.videos = [data.videos] }
    
          await axios.post(`${API_NOTICE}`,data).then(response => {
            if(response.data){
              toggle();
              getNotices();
              reset();
              toast.success("¡Anuncio creado con éxito!", {position: 'bottom-right', style:{color:'white'}});
            }
            setSaveNotice(false);
          }).catch(e => {
            setSaveNotice(false);
            toast.error("No se pudo crear el anuncio: " + e.message, {position: 'bottom-right', style:{color:'white'}});
          });
        }
      } catch (error) {
        setSaveNotice(false);
        toast.error("Error al subir archivos: " + error.message, {position: 'bottom-right', style:{color:'white'}});
      }
    } else {
      errors.showMessages();
    }
  };

  const [currentNotice, setCurrentNotice] = useState({});
  const handleEditAction = (notice, refresh) => {
    if(refresh){toggle()}
    setEditinNotice(true);
    setCurrentNotice(notice);
    
    setTimeout(()=>{
      setValue('title', notice.title);
      setContent(notice.description);
      if(notice.urls!==''){
        setValue('urls', notice.urls[0]);
      }else{
        setValue('urls', notice.urls);
      }
      if(notice.videos!==''){
        setValue('videos', notice.videos[0]);
      }else{
        setValue('videos', notice.videos);
      }
    },500)
  }

  const handleDeleteAction = (data) => {
    SweetAlert.fire({
      title: "¿Continuamos?",
      text: `Se eliminará el anuncio de forma definitiva`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Si",
      cancelButtonText: "Cancelar",
      reverseButtons: true,
    }).then(async (result) => {
      if (result.value) {
        try {
          // Delete associated files
          if (data.pictures && data.pictures.length > 0) {
            for (const pictureUrl of data.pictures) {
              const filename = extractFilenameFromUrl(pictureUrl);
              if (filename) {
                await deleteFile(filename);
              }
            }
          }
          
          if (data.files && data.files.length > 0) {
            for (const fileUrl of data.files) {
              const filename = extractFilenameFromUrl(fileUrl);
              if (filename) {
                await deleteFile(filename);
              }
            }
          }

          await axios.delete(`${API_NOTICE}/${data.uuid}`).then(response => {
            getNotices();
            SweetAlert.fire("¡Listo!", "anuncio eliminado", "success");
          }).catch(error => {
            setTimeout(() => {
              toast.error(
                "Error al eliminar el anuncio: " + error
              );
            }, 200);
          });
        } catch (error) {
          console.error('Error deleting files:', error);
          // Continue with deletion even if file deletion fails
          await axios.delete(`${API_NOTICE}/${data.uuid}`).then(response => {
            getNotices();
            SweetAlert.fire("¡Listo!", "anuncio eliminado", "success");
          }).catch(error => {
            setTimeout(() => {
              toast.error(
                "Error al eliminar el anuncio: " + error
              );
            }, 200);
          });
        }
      }
    });
  }

  const [removingPdf, setRemovingPdf] = useState(false);

  const handleRemovePdf = async (data) => {
    SweetAlert.fire({
      title: "¿Continuamos?",
      text: `Se eliminará el PDF Adjunto del anuncio`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Si",
      cancelButtonText: "Cancelar",
      reverseButtons: true,
    }).then(async (result) => {
      if (result.value) {
        setRemovingPdf(true);

        try {
          // Delete the PDF file
          if (data.files && data.files.length > 0) {
            const filename = extractFilenameFromUrl(data.files[0]);
            if (filename) {
              await deleteFile(filename);
            }
          }

          await axios.patch(`${API_NOTICE}/${data.uuid}`,{files:[]}).then(response => {
            handleEditAction(response.data, false);
            getNotices();
            setRemovingPdf(false);
            SweetAlert.fire("¡Listo!", `PDF eliminado`, "success");
          }).catch(error => {
            setTimeout(() => {
              toast.error(
                "Error al eliminar la PDF: " + error
              );
            }, 200);
          });
        } catch (error) {
          console.error('Error deleting PDF file:', error);
          // Continue with deletion even if file deletion fails
          await axios.patch(`${API_NOTICE}/${data.uuid}`,{files:[]}).then(response => {
            handleEditAction(response.data, false);
            getNotices();
            setRemovingPdf(false);
            SweetAlert.fire("¡Listo!", `PDF eliminado`, "success");
          }).catch(error => {
            setTimeout(() => {
              toast.error(
                "Error al eliminar la PDF: " + error
              );
            }, 200);
          });
        }
      }
    });
  }

  const [isEditingNotice, setEditinNotice] = useState(false);
  const [patchingNotice, setPatchingNotice] = useState(false);
  const patchNotice = async (data) => {
    setPatchingNotice(true);

    if (data !== "") {
      data.description = content;

      try {
        // Upload PDF if exists
        if(filePDF !== ''){
          const pdfUrl = await uploadDocument(filePDF);
          data.files = [pdfUrl];
        }

        // Upload image if exists
        if(fileImage !== ''){
          let file = fileImage;

          new Compressor(file, {
            quality: 0.8,
            success: async (compressedResult) => {   
              const compressed = compressedResult;
              
              const imageUrl = await uploadImage(compressed);
              data.pictures = [imageUrl];
              
              if(data.urls !== ''){data.urls = [data.urls] }
              if(data.videos !== ''){data.videos = [data.videos] }
        
              await axios.patch(`${API_NOTICE}/${currentNotice.uuid}`,data).then(response => {
                if(response.data){
                  getNotices();
                  toggle();
                  setPatchingNotice(false);
                  toast.success("¡Anuncio actualizado con éxito!", {position: 'bottom-right', style:{color:'white'}});
                }
                setPatchingNotice(false);
              }).catch(e => {
                setPatchingNotice(false);
                toast.error("No se pudo actualizar el anuncio: " + e.message, {position: 'bottom-right', style:{color:'white'}});
              });
            },
            error: (err) => {
              toast.error("Error al comprimir la imagen: "+err, {position: 'bottom-right', style:{color:'white'}});
              setPatchingNotice(false);
            }
          });
        } else {
          if(data.urls !== ''){data.urls = [data.urls] }
          if(data.videos !== ''){data.videos = [data.videos] }
    
          await axios.patch(`${API_NOTICE}/${currentNotice.uuid}`,data).then(response => {
            if(response.data){
              getNotices();
              toggle();
              setPatchingNotice(false);
              toast.success("¡Anuncio actualizado con éxito!", {position: 'bottom-right', style:{color:'white'}});
            }
            setPatchingNotice(false);
          }).catch(e => {
            setPatchingNotice(false);
            toast.error("No se pudo actualizar el anuncio: " + e.message, {position: 'bottom-right', style:{color:'white'}});
          });
        }
      } catch (error) {
        setPatchingNotice(false);
        toast.error("Error al subir archivos: " + error.message, {position: 'bottom-right', style:{color:'white'}});
      }
    } else {
      errors.showMessages();
    }
  }

  const [removingPicture, setRemovingPicture] = useState(false);
  const handleRemovePicture = async () => {    
    SweetAlert.fire({
      title: "¿Continuamos?",
      text: `Se eliminará la imagen del anuncio`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Si",
      cancelButtonText: "Cancelar",
      reverseButtons: true,
    }).then(async (result) => {
      if (result.value) {
        setRemovingPicture(true);

        try {
          // Delete the image file
          if (currentNotice.pictures && currentNotice.pictures.length > 0) {
            const filename = extractFilenameFromUrl(currentNotice.pictures[0]);
            if (filename) {
              await deleteFile(filename);
            }
          }

          await axios.patch(`${API_NOTICE}/${currentNotice.uuid}`,{pictures:[]}).then(response => {
            handleEditAction(response.data, false);
            getNotices();
            setRemovingPicture(false);
            SweetAlert.fire("¡Listo!", `imagen eliminada`, "success");
          }).catch(error => {
            setTimeout(() => {
              toast.error(
                "Error al eliminar la imagen: " + error
              );
            }, 200);
          });
        } catch (error) {
          console.error('Error deleting image file:', error);
          // Continue with deletion even if file deletion fails
          await axios.patch(`${API_NOTICE}/${currentNotice.uuid}`,{pictures:[]}).then(response => {
            handleEditAction(response.data, false);
            getNotices();
            setRemovingPicture(false);
            SweetAlert.fire("¡Listo!", `imagen eliminada`, "success");
          }).catch(error => {
            setTimeout(() => {
              toast.error(
                "Error al eliminar la imagen: " + error
              );
            }, 200);
          });
        }
      }
    });
  }

  const [content, setContent] = useState("");
  const onChange = (evt) => {
    const newContent = evt.editor.getData();
    setContent(newContent);
  };

  useEffect(() => {
    getNotices();
  }, []);

  return (
    <Fragment>
      <Breadcrumb parent="Inicio" title="Bienvenid@" subtitle={user.name} />
      <Container fluid={true}>
        <>
          { 
            !loadingTimeline ?
              timeline.length > 0 ?
              <VerticalTimeline>
                {timeline.map(time=>{
                  let icon = <Edit />;
                  if(time.pictures && time.pictures.length>0){
                    icon = <Image />
                  }
                  if(time.videos && time.videos.length>0){
                    icon = <Video />
                  }
                  const date = (() => {
                    try {
                      const parsedDate = new Date(time.createdAt);
                      if (isNaN(parsedDate.getTime())) {
                        return new Date();
                      }
                      return parsedDate;
                    } catch (error) {
                      return new Date();
                    }
                  })();
                  return(
                    <>
                      <VerticalTimelineElement
                        key={time.uuid}
                        className="vertical-timeline-element--work"
                        animate={true}
                        date={date.toLocaleString('es-MX', {
                          timeZone: 'UTC',
                          year: 'numeric',
                          month: 'long',
                          day: 'numeric',
                          hour: '2-digit',
                          minute: '2-digit'
                        })}
                        icon={icon}
                      >
                        <h4 className="vertical-timeline-element-subtitle mb-2">
                        {time.title}
                        {user.role === 'ADMIN' || user.role === 'SISTEMAS' ? 
                        <>
                          <Trash onClick={()=>handleDeleteAction(time)} style={{float: 'right', cursor:'pointer'}} size={30} />
                          <Edit3 onClick={()=>handleEditAction(time, true)} style={{float: 'right', cursor:'pointer', marginRight: 15}} size={30} />
                        </>
                        : null }
                        </h4>
                        <h7>
                          <b><User size={15} /> Publicado por: {time.creatorName}</b>
                        </h7>
                        <div style={{marginTop:20}} dangerouslySetInnerHTML={{__html:time.description}}></div>
                        {time.urls && time.urls.length>0 ?
                          <p>Enlaces: <a href={time.urls[0]} target="_blank">{time.urls[0]}</a></p>
                        : null}
                        {time.files && time.files.length>0 ?
                        <a href={time.files[0]} target="_blank">
                        PDF Adjunto</a>: null}
                        {time.pictures && time.pictures.length>0 ?
                        <a href={time.pictures[0]} target="_blank">
                        <img
                          className="img-fluid p-t-20 w-100"
                          src={time.pictures[0]}
                          alt="timelineImg"
                        /></a>: null}
                        {time.videos && time.videos.length>0 ?
                        <div className="embed-responsive embed-responsive-21by9 ratio ratio-21x9 m-t-20">
                          <iframe
                            src={time.videos[0]}
                            allowFullScreen
                            title="videotimeline"
                          ></iframe>
                        </div>: null}
                      </VerticalTimelineElement>
                    </>
                  )
                })}
              </VerticalTimeline>
              : <h3 className="text-secondary" style={{textAlign:'center'}}>Sin anuncios por ahora</h3>
            : <h3 className="text-secondary" style={{textAlign:'center'}}>Cargando...</h3> }
          {
            user !== null && user !== undefined && user.role === 'ADMIN' ?
              <>
                <Modal isOpen={modal} toggle={toggle}>
                  <ModalHeader toggle={toggle}>{isEditingNotice ? 'Editar Anuncio' : 'Crear nuevo Anuncio' }
                    <button className="btn-close invisible" type="button">
                      <span aria-hidden="true" className="visible" onClick={toggle}></span>
                    </button>
                  </ModalHeader>
                  <ModalBody>
                    <div className="container">
                      <Form className="needs-validation" noValidate="" onSubmit={handleSubmit( isEditingNotice ? patchNotice : saveNotice)} style={{padding:20}}>
                        <Row className="g-3 dflex mb-3">
                          <Col md="12">
                            <Label className="form-label font-weight-bold" for="validTitle">
                              Titulo
                            </Label>
                            <input className="form-control" id="validTitle" type="text" placeholder="Titulo" name="title" {...register("title", { required: true })} />
                            <span>{errors.title && "Titulo requerido"}</span>
                          </Col>
                        </Row>
                        <Row className="g-3 dflex mb-3">
                          <Col md="12">
                            <Label className="form-label font-weight-bold" for="validDetails">
                              Detalles
                            </Label>
                            <CKEditors
                              activeclassName="p10"
                              content={content}
                              events={{
                                change: onChange,
                              }}
                            />
                          </Col>
                        </Row>
                        <Row className="g-3 dflex mb-4">
                          <Col md="12">
                            <Label className="form-label font-weight-bold">
                              Imagen
                            </Label>&nbsp;
                            {isEditingNotice ?
                              <>
                                {currentNotice.pictures !== null && currentNotice.pictures !== undefined && currentNotice.pictures.length > 0 ?
                                <div>
                                  <img src={`${currentNotice.pictures[0]}`} style={{maxWidth:300}} />
                                  <p>{!removingPicture ? <span onClick={handleRemovePicture} style={{color:'red', cursor:'pointer'}}>Quitar</span> : null}</p>
                                </div>
                                : 
                                <input type="file" className="form-control" accept="image/*" onChange={(e)=>{if (e.target.files[0].size > 2000000) {
                                  toast.error("El archivo no puede pesar más de 2MB",{position: 'bottom-right', style:{color:'white'}});
                                  e.target.files = null;
                                  e.target.value = null;
                                  return;
                                }setFileImage(e.target.files[0])}}/>
                                }
                              </>
                            :
                            <input type="file" className="form-control" accept="image/*" onChange={(e)=>{if (e.target.files[0].size > 2000000) {
                              toast.error("El archivo no puede pesar más de 2MB",{position: 'bottom-right', style:{color:'white'}});
                              e.target.files = null;
                              e.target.value = null;
                              return;
                            }setFileImage(e.target.files[0])}}/>}
                          </Col>
                        </Row>
                        <Row className="g-3 dflex mb-4">
                          <Col md="12">
                            <Label className="form-label font-weight-bold">
                              PDF
                            </Label>&nbsp;
                            {isEditingNotice ?
                              <>
                                {currentNotice.files !== null && currentNotice.files !== undefined && currentNotice.files.length > 0 ?
                                <div>
                                  <a href={currentNotice.files[0]} target="_blank">{currentNotice.files[0]}</a>
                                  <p>{!removingPicture ? <span onClick={()=>handleRemovePdf(currentNotice)} style={{color:'red', cursor:'pointer'}}>Quitar</span> : null}</p>
                                </div>
                                : 
                                <input type="file" className="form-control" accept="application/pdf" onChange={(e)=>{if (e.target.files[0].size > 2000000) {
                                  toast.error("El PDF no puede pesar más de 2MB",{position: 'bottom-right', style:{color:'white'}});
                                  e.target.files = null;
                                  e.target.value = null;
                                  return;
                                }setFilePDF(e.target.files[0])}}/>
                                }
                              </>
                            :
                            <input type="file" className="form-control" accept="application/pdf" onChange={(e)=>{if (e.target.files[0].size > 2000000) {
                              toast.error("El PDF no puede pesar más de 2MB",{position: 'bottom-right', style:{color:'white'}});
                              e.target.files = null;
                              e.target.value = null;
                              return;
                            }setFilePDF(e.target.files[0])}}/>}
                          </Col>
                        </Row>
                        <Row className="g-3 dflex mb-4">
                          <Col md="12">
                            <Label className="form-label font-weight-bold" for="validUrl">
                              Enlace Web
                            </Label>
                            <input className="form-control" id="validUrl" type="text" placeholder="Enlace Web https://" name="urls" {...register("urls")} />
                          </Col>
                        </Row>
                        <Row className="g-3 dflex mb-4">
                          <Col md="12">
                            <Label className="form-label font-weight-bold" for="validYoutube">
                              Video Youtube
                            </Label>
                            <input className="form-control" id="validYoutube" type="text" placeholder="Video Youtube Embeded https://" name="videos" {...register("videos")} />
                          </Col>
                        </Row>
                        <Row style={{display:'flex', justifyContent:'end', paddingTop:20}}>
                        {
                          isEditingNotice ? 
                            <Button disabled={patchingNotice} className="btn btn-primary" style={{width:150}} color="primary">{"Guardar"}</Button> 
                          : 
                            <Button disabled={savingNotice} className="btn btn-primary" style={{width:150}} color="primary">{"Publicar"}</Button> 
                        }
                        </Row>
                      </Form>
                    </div>
                  </ModalBody>
                </Modal>
                <div onClick={toggle} style={{position: 'fixed', fontWeight:'bold', background: 'black', padding: 15, borderRadius: 50, color: 'white', width: 60, height:60, right: 30, bottom: 30, cursor: 'pointer', zIndex:100}}>
                  <Plus size={30} />
                </div>
              </>
            : null
          }
        </>
      </Container>
    </Fragment>
  );
};

export default Home;
